<template>
    <div id="main">
        <div class="cta  flex flex-row items-center justify-center p-4 " style="background-image:url('/img/hero.png')">
       <div class="d-img">

            <img class="" src="/img/doctor.PNG" alt="" style="width:28rem">
        </div> <div class="cta-text flex flex-col items-start">
            <h3 class="head-text py-2 font-semibold">Saving Lives by
                Revolutionizing the
                way Blood is Delivered
                </h3>
               <p class="py-2 p"> Cover all your blood purchases, sells and logistic needs...</p>
               <ul class="flex flex-row ">
                <li class="list">
                    <p>30+</p>
                    <span>CITIES</span>
                </li>
                <li class="list middle">
                    <p>250+</p>
                    <span>PARTNERS</span>
                </li>
                <li class="list">
                    <p>1000+</p>
                    <span>DRONES</span>
                </li>
            </ul>
               <router-link to="/CreateAccount"
                            class="py-2  px-14  border register bg-red-500 text-white
                                hover:bg-red-600 hover:text-white font-semibold border border-red-500 
                                rounded shadow">Register
                            </router-link>
        </div>
        
        </div>
        <div style="background-image: url('/img/about-back.svg')" class="cta about p-4 text-center">
        <div class="space">
            <h4 class="py-4">BLOOD HQ TO THE RESCUE</h4>
            <p class="font-medium yuo my-1">The pandemic has proven the usefulness and suitability of drones to facilitate medical deliveries at the last-mile.  Blood Headquaters is your first organised drone API System.</p>
            
            <router-link to='/' class="py-2 text-red-600 font-medium read text-xs uppercase hover:underline"> Read More <span>&rarr;</span></router-link>
        </div></div>
        <div class="cta flex flex-row m-4 justify-evenly items-center">
            <div class="phone"><img src="/img/gg.png" alt=""></div>
            <div class="cta-list">
            <h4 class="font-medium my-1">PUT YOUR HOSPITAL ON THE MAP</h4>
            <p class="font-medium font-lg my-1">Partner with us today:</p>
            <ul class="font-medium">
                <li class="flex flex-row items-center"><img class="w-8" src="/img/note.svg" alt=""><span>Register and fill in your verification details</span></li>
                <li class="flex flex-row items-center"><img class="w-8" src="/img/downApp.svg" alt=""><span>Download Mobile App</span></li>
                <li class="flex flex-row items-center"><img class="w-8" src="/img/drop.svg" alt=""><span>Order and Sell Blood</span></li>
            </ul>
            </div>
            
        </div>
        <div class="cta flex flex-row items-center justify-evenly my-4">
            <div class="card">
                <img src="/img/speed.svg" alt="">
                <p >Speedy Delivery</p>
            </div>
            <div class="card">
                <img src="/img/group.svg" alt="">
                <p>Customer Friendly</p>
            </div>
            <div class="card">
                <img src="/img/talking.svg" alt="">
                <p>Tested and Trusted</p>
            </div>
        </div>
    </div>
</template> 
<style lang="scss" scoped>
.cta:first-of-type {
    padding: 1em 0;
}
.cta-text {
    max-width: 27em;
}
.list {
    margin: 0 0 0 1em;
    font-weight: 700;

    span {
        font-size: .6em;
        font-weight: 600;
    }
}
.middle {
    border-left: 1px solid;
    padding: 0em 1em;
    border-right: 1px solid  ;
}
h3.head-text {
    font-size: 2.5em !important;
    white-space: wrap;
    font-weight: 800;
}
.about {
    padding: 10em 0;
    
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
@media (max-width: 445px) {
    h3.head-text {
    font-size: 2em !important;
   
}
    .p {
    font-size: 1em;
}
.d-img {
    margin: 1em !important;
    width: 70%;
}
    .cta {
        flex-wrap: wrap;
        padding: 1em;
        .cta-text {
            order: 1;
            width: 80%;
            margin: 0em 0;
            display: flex;
            flex-direction: column;

        }
        .register {
            width: 12em;
        }
}
}
.register {
            width: 12em;
        }
.d-img {
    margin:1em 5em 0 0;
}
.space {
    margin: 0 auto;
    max-width: 50em;
   
    .read {
        margin: 2em 0 !important;
    }
}
#main {
     font-family: 'DM Sans', sans-serif;
    

}
.yuo {
    max-width: 100% !important;
}
.phone {
     max-width: 18em;
    img {
        width: 100%
    }
}
.register {
    margin: 2em 0;
}
h4 {
    font-weight: 600;
    font-size: 2em;
}
.cta-list {
    li {
        span {
             margin: 1em 1em
        }
    }
   
}

.card {
    min-width: 15em;
    margin: 1em 0;
    text-align: center;
    img {
        width: 100%;
    }
    p {
        font-weight: 500;
        margin: 1em 0
    }
    img {
        margin: 0 auto;
    }
}
</style>
